const OPEN_ASSISTANT_QUERY_KEY = 'openAssistant'

export function consumeOpenAssistantQuery({ route, router, store }) {
  const query = route?.query || {}
  if (query[OPEN_ASSISTANT_QUERY_KEY] === undefined) return

  const { [OPEN_ASSISTANT_QUERY_KEY]: requested, ...rest } = query
  const canOpenAssistant = requested === '1'
    && !!store.state.currentUser?.id
    && store.getters['aiChatbot/canUseAIChatbot']
    && store.getters['aiChatbot/canUsePresenterToolBridge']
  if (canOpenAssistant) store.dispatch('aiChatbot/openGlobalPanelAction')

  const navigation = router.replace({ query: rest })
  if (navigation && typeof navigation.catch === 'function') navigation.catch(() => {})
}

export default {
  computed: {
    openAssistantQueryFlagsLoaded() {
      return !!this.$store.state.currentUser?.id
        && !!this.$store.getters['featureToggles/hasLoadedAuthFlag']
        && !!this.$store.getters['featureSettings/isFeatureSettingsLoaded']
    },
  },
  mounted() {
    this.$watch('$route', this.consumeOpenAssistantQueryWhenReady)
    this.$watch('openAssistantQueryFlagsLoaded', (loaded) => { if (loaded) this.consumeOpenAssistantQueryWhenReady() })
    this.consumeOpenAssistantQueryWhenReady()
  },
  methods: {
    consumeOpenAssistantQueryWhenReady() {
      if (!this.openAssistantQueryFlagsLoaded) return
      consumeOpenAssistantQuery({ route: this.$route, router: this.$router, store: this.$store })
    },
  },
}
